import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import { pca, initializeMsal } from './auth_config';

// Inicializar MSAL e renderizar a aplicação
const initializeApp = async () => {
  try {
    await initializeMsal();
    
    const container = document.getElementById('root');
    const root = ReactDOM.createRoot(container);

    root.render(
      <React.StrictMode>
        <MsalProvider instance={pca}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Erro ao inicializar a aplicação:', error);
    
    // Fallback: renderizar página de erro
    const container = document.getElementById('root');
    const root = ReactDOM.createRoot(container);
    
    root.render(
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        backgroundColor: '#f3f4f6'
      }}>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <h1 style={{ color: '#dc2626', marginBottom: '1rem' }}>Erro de Inicialização</h1>
          <p style={{ color: '#6b7280' }}>Não foi possível inicializar a aplicação.</p>
          <p style={{ color: '#6b7280', fontSize: '0.875rem', marginTop: '0.5rem' }}>
            Verifique a configuração do MSAL e tente novamente.
          </p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1rem',
              backgroundColor: '#4682B4',
              color: 'white',
              border: 'none',
              borderRadius: '0.375rem',
              cursor: 'pointer'
            }}
          >
            Tentar Novamente
          </button>
        </div>
      </div>
    );
  }
};

// Inicializar a aplicação
initializeApp();
